import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazyNamed(() => import('./Helmet.tsx'), 'Helmet'),
  PageImpressions: lazyNamed(() => import('./pages/PageImpressions/index.tsx'), 'PageImpressions'),
  AdImpressions: lazyNamed(() => import('./pages/AdImpressions/index.tsx'), 'AdImpressions'),
};
